import * as React from 'react';
import { Table, Typography } from 'antd';
import { Tree, TreeValidation } from 'tree-wallet-client';
import { formatUTCDateFromDateString } from '../../Helper/DateHelper';

const { Text } = Typography;

interface ValidationTableProps {
  tree: Tree;
  // isVisible: boolean;
}

interface ValidationRecord {
  id: number;
  date: string;
  description: string;
}

export default function ValidationTable({ tree }: ValidationTableProps) {
  if (!tree.treeValidations || tree.treeValidations.length === 0) {
    return null;
  }

  // Sort validations by createdAt in descending order (newest first)
  const sortedValidations = [...tree.treeValidations].sort((a, b) =>
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  const validationRecords: ValidationRecord[] = sortedValidations.map((validation: TreeValidation) => {
    const formattedDate = formatUTCDateFromDateString(validation.createdAt);
    const yesAnswers = [];

    if (validation.leavesFallOff === 'Yes') yesAnswers.push('Leaves fall off');
    if (validation.cutDown === 'Yes') yesAnswers.push('Tree cut down');
    if (validation.eaten === 'Yes') yesAnswers.push('Got eaten');
    if (validation.dugUp === 'Yes') yesAnswers.push('Got dug up');
    if (validation.burned === 'Yes') yesAnswers.push('Got burned');
    if (validation.leavesResprout === 'Yes') yesAnswers.push('Leaves resprout');

    // Build description parts without the date
    const descriptionParts = [`Tree status: ${validation.status}`];

    // Add yes answers if any
    if (yesAnswers.length > 0) {
      descriptionParts.push(yesAnswers.join(', '));
    }

    // Add comment if exists
    if (validation.comment) {
      descriptionParts.push(validation.comment);
    }

    /* if (validation.orientation !== undefined && validation.orientation !== null) {
      descriptionParts.push(`Heading: ${Math.round(validation.orientation)}°`);
    } */

    // Add validator info
    descriptionParts.push(`Validation made by ${validation.validatedBy.firstName} ${validation.validatedBy.lastName}`);

    // Filter out empty parts and join with proper spacing
    const filteredParts = descriptionParts.filter(part => part && part.trim() !== '');
    const description = filteredParts.join(' - ');

    return {
      id: validation.id,
      date: `${formattedDate.date}\n${formattedDate.time} (UTC)`,
      description: description
    };
  });

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: '140px',
      render: (text: string) => (
        <div style={{ whiteSpace: 'pre-line' }}>
          {text}
        </div>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    }
  ];

  return (
    <div style={{ marginTop: '20px' }}>
      <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '12px' }}>
        Validations
      </Text>
      <Table
        columns={columns}
        dataSource={validationRecords}
        rowKey="id"
        pagination={false}
      />
    </div>
  );
}
